// extracted by mini-css-extract-plugin
export default {"error":"QuoteForm_error__-T5jK","hidden":"QuoteForm_hidden__HzIG1"};